import { h } from 'preact'
import { ForwardFn, forwardRef } from 'preact/compat'
import cls from 'classnames'

import classes from '../../components/TextInputComp/index.scss'
import textAreaClasses from './index.scss'
import { TextInputCompProps } from '../../components/TextInputComp/type'

const TextArea: ForwardFn<TextInputCompProps, HTMLTextAreaElement> = (props, ref) => {
  const { value, onChange, placeholder, className } = props

  const handleChange = (evt: any) => {
    onChange(evt.target.value)
  }

  return (
    <textarea
      ref={ref}
      className={cls(classes.input, textAreaClasses.textarea, className)}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
    />
  )
}

export default forwardRef(TextArea)
